import useEffectOnce from 'react-use/lib/useEffectOnce';

import {
  type Filter,
  type FilterEditorComponentProps,
  createFilter,
} from './provider';

const ToggleFilterEditor = ({
  onValueChange,
  onClose,
}: FilterEditorComponentProps<boolean>) => {
  useEffectOnce(() => {
    onValueChange(true);
    onClose();
  });

  return null;
};

export const createToggleFilter = (config: Omit<Filter<boolean>, 'editor'>) =>
  createFilter({ ...config, editor: ToggleFilterEditor });
